/**
 * @generated SignedSource<<e7ac87b769771af1d60c138c72fa1c6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteDraftInvoiceInput = {
  clientMutationId?: string | null | undefined;
  invoiceId: string;
};
export type DeleteDraftInvoiceMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteDraftInvoiceInput;
};
export type DeleteDraftInvoiceMutation$data = {
  readonly deleteDraftInvoice: {
    readonly deletedInvoiceId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type DeleteDraftInvoiceMutation = {
  response: DeleteDraftInvoiceMutation$data;
  variables: DeleteDraftInvoiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedInvoiceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteDraftInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftInvoicePayload",
        "kind": "LinkedField",
        "name": "deleteDraftInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteDraftInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftInvoicePayload",
        "kind": "LinkedField",
        "name": "deleteDraftInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedInvoiceId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "367cda3618b8b82312b084b27e2f7171",
    "id": null,
    "metadata": {},
    "name": "DeleteDraftInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteDraftInvoiceMutation(\n  $input: DeleteDraftInvoiceInput!\n) {\n  deleteDraftInvoice(input: $input) {\n    success\n    errors\n    deletedInvoiceId\n  }\n}\n"
  }
};
})();

(node as any).hash = "946bd51abc5634adef3213841f276c3f";

export default node;
